// generated by the plop

import { TabModel } from '../../symbols';

export class AddTab {
  static type = '[tabsNav] AddTab';

  constructor(public tab: TabModel) {
  }
}


export class CloseTab {
  static type = '[tabsNav] CloseTab';

  constructor(public tab: TabModel) {
  }
}


export class CloseTabSuccess {
  static type = '[tabsNav] CloseTabSuccess';

  constructor(public tab: TabModel) {
  }
}


export class UpdateTabLabel {
  static type = '[tabsNav] UpdateTabLabel';

  constructor(public tab: TabModel) {
  }
}


export class ConfirmCloseTab {
  static type = '[tabsNav] ConfirmCloseTab';

  constructor(public tab: TabModel) {
  }
}

export class ChangeTabIndex {
  static type = '[tabsNav] ChangeTabIndex';

  constructor(public prevIndex: number, public currentIndex: number) {
  }
}
